import type { MessageVariant } from 'components/Message';
import type { ErrorLevel } from 'models/api';
import type { MessageSeverity } from 'models/sitecore';

const severityToVariantMap: Record<
	ErrorLevel | MessageSeverity,
	MessageVariant
> = {
	'': 'information',
	'Information': 'information',
	'Info': 'information',
	'Warning': 'warning',
	'Critical': 'error',
	'Error': 'error',
};
export function mapSeverityToVariant(
	severity: ErrorLevel | MessageSeverity | undefined,
) {
	return severity ? severityToVariantMap[severity] : 'information';
}
